var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{directives:[{name:"stat",rawName:"v-stat:click",value:({action:'ZNZT_2023chick_03',extend:{
    hotspotId: _vm.hotspotId,
    typeId: _vm.typeId,
    seriesId: _vm.seriesId,
    specId: _vm.specId
  }}),expression:"{action:'ZNZT_2023chick_03',extend:{\n    hotspotId,\n    typeId,\n    seriesId,\n    specId\n  }}",arg:"click"},{name:"stat",rawName:"v-stat:show",value:({action:'ZNZT_2023show_02',extend:{
    hotspotId: _vm.hotspotId,
    typeId: _vm.typeId,
    seriesId: _vm.seriesId,
    specId: _vm.specId
  }}),expression:"{action:'ZNZT_2023show_02',extend:{\n    hotspotId,\n    typeId,\n    seriesId,\n    specId\n  }}",arg:"show"}],staticClass:"hot-dot",attrs:{"title":_vm.salesInfo},on:{"click":function($event){return _vm.openCarPic(_vm.typeId,_vm.seriesId,_vm.specId)}}})}
var staticRenderFns = []

export { render, staticRenderFns }